import { Box } from '@chakra-ui/react';
import { components, GroupBase, OptionProps } from 'react-select';

import { DropdownOption } from '../../DropdownInput/typings';

const OptionWrapper = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: OptionProps<Option, IsMulti, Group>,
) => {
  return (
    <components.Option {...props}>
      <Box data-testid='fuzzy_option'>{props.children}</Box>
    </components.Option>
  );
};

export default OptionWrapper;
